const positionTooltipX = (tooltip) => {
  if (typeof window !== "undefined" && tooltip?.offsetParent) {
    const content = tooltip.getBoundingClientRect();
    const parent = tooltip.offsetParent.getBoundingClientRect();
    const { innerWidth } = window;
    const offsetPadding = parseInt(
      getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-padding")
    );
    const overflowLeft = -(parent.left + parent.width / 2 - content.width / 2 - offsetPadding);
    const overflowRight = -(parent.left + parent.width / 2 + content.width / 2 + offsetPadding - innerWidth);
    if (overflowLeft > 0) {
      tooltip.style.setProperty("--tds-tooltip--x-offset", `${overflowLeft}px`);
    }
    if (overflowRight < 0) {
      tooltip.style.setProperty("--tds-tooltip--x-offset", `${overflowRight}px`);
    }
  }
};
const positionTooltipY = (tooltip) => {
  if (typeof window !== "undefined" && tooltip?.offsetParent) {
    const content = tooltip.getBoundingClientRect();
    const parent = tooltip.offsetParent.getBoundingClientRect();
    const { innerHeight } = window;
    const safeSpace = getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--safe-space");
    const offsetPadding = parseInt(
      getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-padding")
    );
    tooltip.style.removeProperty("top");
    tooltip.style.removeProperty("bottom");
    if (parent.bottom + content.height + offsetPadding > innerHeight) {
      tooltip.style.setProperty("top", "auto");
      tooltip.style.setProperty("bottom", `calc(100% + ${safeSpace})`);
    }
    if (parent.top - content.height - offsetPadding < 0) {
      tooltip.style.setProperty("top", `calc(100% + ${safeSpace})`);
      tooltip.style.setProperty("bottom", "auto");
    }
  }
};
const setTooltipOverlayY = (tooltip, orientation, parentModal) => {
  if (typeof window !== "undefined" && tooltip?.parentNode) {
    const parent = tooltip.parentElement?.getBoundingClientRect();
    const content = tooltip.getBoundingClientRect();
    const dialog = parentModal?.getBoundingClientRect();
    if (!parent)
      return;
    const parentY = dialog ? parent.y - dialog.y : parent.y;
    const offsetAlign = parseInt(
      getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-align")
    );
    const overflowTop = -(parentY - content.height - offsetAlign);
    const overflowBottom = window.innerHeight - (parentY + parent.height) - content.height + offsetAlign;
    const aboveParentY = parentY - content.height - offsetAlign;
    const belowParentY = parentY + parent.height + offsetAlign;
    const positionTop = orientation === "down" ? overflowBottom < 0 ? aboveParentY : belowParentY : overflowTop > 0 ? belowParentY : aboveParentY;
    tooltip.style.top = `${positionTop}px`;
  }
};
const setTooltipOverlayX = (tooltip, align, fullWidth, parentModal) => {
  if (typeof window !== "undefined" && tooltip?.parentNode) {
    const parent = tooltip.parentElement?.getBoundingClientRect();
    const content = tooltip.getBoundingClientRect();
    const dialog = parentModal?.getBoundingClientRect();
    if (!parent)
      return;
    const parentX = dialog ? parent.x - dialog.x : parent.x;
    if (fullWidth) {
      tooltip.style.left = `${parentX}px`;
      tooltip.style.inlineSize = `${parent.width}px`;
      tooltip.style.maxInlineSize = `${parent.width}px`;
    } else {
      const offsetPadding = parseInt(
        getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-padding")
      );
      const offsetAlign = parseInt(
        getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-align")
      );
      let startX = -content.width / 2 + parent.width / 2 + offsetAlign / 2;
      if (align === "end")
        startX = -content.width + offsetAlign + parent.width;
      if (align === "start")
        startX = -offsetAlign;
      const overflowLeft = -(parentX + startX - offsetPadding);
      const overflowRight = window.innerWidth - (parentX + startX) - content.width - offsetPadding;
      const positionX = parentX + startX + Math.min(0, overflowRight) + Math.max(0, overflowLeft);
      tooltip.style.left = `${positionX}px`;
    }
  }
};
const positionTooltipOverlay = (tooltip, align, orientation, fullWidth) => {
  const parentModal = getBlockFormattingContainer(tooltip.parentElement);
  setTooltipOverlayX(tooltip, align, Boolean(fullWidth), parentModal);
  setTooltipOverlayY(tooltip, orientation, parentModal);
};
const positionTooltip = (tooltip) => {
  positionTooltipX(tooltip);
  positionTooltipY(tooltip);
};
function getTooltipModifiers(tooltip) {
  const overlay = tooltip.classList.contains("tds-tooltip--overlay");
  const fullWidth = tooltip.classList.contains("tds-tooltip--width-full");
  let align = null;
  let orientation = null;
  if (tooltip.classList.contains("tds-tooltip--align-start")) {
    align = "start";
  }
  if (tooltip.classList.contains("tds-tooltip--align-end")) {
    align = "end";
  }
  if (tooltip.classList.contains("tds-tooltip--orientation-down")) {
    orientation = "down";
  }
  return { align, fullWidth, orientation, overlay };
}
const getBlockFormattingContainer = (element) => {
  const style = element ? getComputedStyle(element) : null;
  const isFixed = style && style.getPropertyValue("position") === "fixed";
  const isOverflowing = style && ["auto", "scroll"].includes(style.getPropertyValue("overflow"));
  if (isFixed && isOverflowing) {
    return element;
  } else {
    return element && getBlockFormattingContainer(element.parentElement);
  }
};
const initTooltip = (tooltip, props) => {
  const { closeOnBlur, isClickToOpen, onClose, onOpen } = props;
  const { align, fullWidth, orientation, overlay } = getTooltipModifiers(tooltip);
  const opener = tooltip.parentElement?.querySelector("[data-tds-tooltip-trigger]");
  let scrollTimeout;
  const setTooltipPosition = () => {
    if (overlay) {
      positionTooltipOverlay(tooltip, align, orientation, fullWidth);
    } else {
      positionTooltip(tooltip);
    }
  };
  setTooltipPosition();
  const closeTooltipIfOutside = (e) => {
    if (!tooltip.parentElement?.contains(e.target)) {
      closeTooltip(e);
    }
  };
  const handleWindowKeyDown = (e) => {
    if (e.key === "Escape" || e.key === "Esc") {
      closeTooltip(e);
    }
  };
  const handleOpenerKeyDown = (e) => {
    const { key } = e;
    if (key === " " || key === "Enter" || key === "ArrowDown") {
      e.preventDefault();
      openTooltip(e);
    }
  };
  const openTooltip = (e) => {
    tooltip.classList.add("tds-tooltip--open");
    tooltip.classList.remove("tds-tooltip--closed");
    setTooltipPosition();
    clearTimeout(scrollTimeout);
    if (overlay)
      window.addEventListener("scroll", setTooltipPosition);
    window.addEventListener("resize", setTooltipPosition);
    document.addEventListener("keydown", handleWindowKeyDown);
    document.addEventListener("click", closeTooltipIfOutside);
    opener?.removeEventListener("click", openTooltip);
    opener?.addEventListener("click", closeTooltip);
    if (onOpen)
      onOpen(e);
  };
  const closeTooltip = (e) => {
    tooltip.classList.remove("tds-tooltip--open");
    tooltip.classList.add("tds-tooltip--closed");
    if (overlay) {
      scrollTimeout = setTimeout(
        () => window.removeEventListener("scroll", setTooltipPosition),
        500
      );
    }
    window.removeEventListener("resize", setTooltipPosition);
    document.removeEventListener("keydown", handleWindowKeyDown);
    document.removeEventListener("click", closeTooltipIfOutside);
    opener?.removeEventListener("click", closeTooltip);
    opener?.addEventListener("click", openTooltip);
    if (onClose)
      onClose(e);
  };
  if (!isClickToOpen) {
    opener?.addEventListener("mouseenter", openTooltip);
    tooltip.parentElement?.addEventListener("mouseleave", closeTooltip);
    tooltip.parentElement?.addEventListener("focusin", openTooltip);
  } else {
    opener?.addEventListener("keydown", handleOpenerKeyDown);
  }
  opener?.addEventListener("click", openTooltip);
  opener?.addEventListener("blur", closeTooltipIfOutside);
  if (closeOnBlur) {
    const handleFocusOut = (event) => {
      const focusedElement = event.relatedTarget;
      if (focusedElement && focusedElement !== opener && !tooltip.contains(focusedElement)) {
        closeTooltip();
      }
    };
    tooltip?.addEventListener("focusout", handleFocusOut);
  }
  if (tooltip.classList.contains("tds-tooltip--open")) {
    openTooltip();
  } else if (tooltip.classList.contains("tds-tooltip--closed")) {
    closeTooltip();
  }
};
const initTooltips = (props = {}) => {
  const { parent = document } = props;
  const tooltips = Array.from(parent.querySelectorAll(".tds-tooltip"));
  tooltips.forEach((component) => {
    initTooltip(component, props);
  });
};
export {
  initTooltip,
  initTooltips,
  positionTooltip,
  positionTooltipOverlay,
  positionTooltipX,
  positionTooltipY,
  setTooltipOverlayX,
  setTooltipOverlayY
};
